import { useFocusable } from '@noriginmedia/norigin-spatial-navigation'
import cx from 'classnames'
import React from 'react'
import { Link } from 'react-router-dom'
import { useSidePanel } from './SidePanelProvider'
import tts from '../../lib/TTS'

import type { SidePanelItemProps } from './types'
import type { FocusHandler } from '@noriginmedia/norigin-spatial-navigation'

const SidePanelItem = ({ title, to, active }: SidePanelItemProps) => {
  const { isSidePanelFocused, onItemFocus } = useSidePanel()

  const handleItemFocus: FocusHandler<{ to: string }> = (_, { to }) => {
    tts.stopRead()
    tts.addTextToRead(title)
    onItemFocus(to)
  }

  const { ref, focused } = useFocusable({
    focusKey: to,
    onFocus: handleItemFocus,
    onArrowPress: (direction) => direction !== 'right' || active,
    extraProps: { to },
  })

  return (
    <li
      className={cx('side-panel-item', {
        'side-panel-item--focused': focused,
        'side-panel-item--active-unfocused':
          active && !isSidePanelFocused && !focused,
      })}
    >
      <Link to={to} ref={ref} className="side-panel-item__link">
        {title}
      </Link>
    </li>
  )
}

export default SidePanelItem
